import { TextFormFieldProps } from 'modules/experiments/types';
import { InputField } from 'lib/iterable-hook-form';
import { StyledVariantFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { ReadOnlyValue } from '../ReadOnlyValue';

export const TextBox = ({
  dataTestId,
  isFieldEditable,
  isFieldFocused = false,
  fieldLabel,
  fieldName,
  fieldValue,
  helperText,
}: TextFormFieldProps) => {
  return (
    <StyledVariantFormField
      data-test={dataTestId}
      labelText={fieldLabel}
      helpText={isFieldEditable ? helperText : null}
      isHorizontalLayout
    >
      {isFieldEditable ? (
        <InputField name={fieldName} autoFocus={isFieldFocused} />
      ) : (
        <ReadOnlyValue>{fieldValue}</ReadOnlyValue>
      )}
    </StyledVariantFormField>
  );
};
